var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectDebitPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.025 24a1.025 1.025 0 010 2.05c-20.939 0-37.975 17.036-37.975 37.975S43.086 102 64.025 102c20.088 0 36.571-15.68 37.881-35.442l-6.174 6.174a.999.999 0 11-1.414-1.414l7.907-7.907c.188-.244.469-.411.8-.411.331 0 .612.167.8.411l7.907 7.907a.999.999 0 11-1.414 1.414l-6.344-6.343c-1.227 20.973-18.673 37.661-39.949 37.661C41.955 104.05 24 86.095 24 64.025S41.955 24 64.025 24zm.098 14.025a1 1 0 011 1v5.706c3.084.187 5.517 1.242 7.228 3.161 3.21 3.602 2.648 8.86 2.623 9.081a1.008 1.008 0 01-1.106.879 1.002 1.002 0 01-.882-1.105c.006-.046.479-4.61-2.137-7.533-1.497-1.673-3.761-2.522-6.727-2.522-8.943 0-9.068 7.7-9.07 8.028v.018c.007.539.243 8.287 8.973 8.287 3.35 0 6.023.979 7.948 2.909 2.872 2.882 3.017 6.86 3.023 7.355v.09c-.006.47-.149 4.242-2.935 7.036-1.716 1.721-4.047 2.693-6.938 2.9v5.71a1 1 0 11-2 0v-5.697c-3.176-.154-5.675-1.21-7.422-3.169-3.212-3.602-2.65-8.858-2.624-9.08.063-.549.57-.933 1.106-.879a1 1 0 01.88 1.105c-.004.046-.477 4.61 2.139 7.533 1.498 1.672 3.76 2.521 6.727 2.521 8.697 0 9.053-7.283 9.067-7.984v-.088c-.014-.726-.363-8.262-8.97-8.262-3.35 0-6.025-.979-7.95-2.91-2.872-2.881-3.017-6.856-3.023-7.352v-.09c.006-.47.15-4.242 2.935-7.036 1.755-1.76 4.156-2.731 7.135-2.908v-5.704a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63B8FF",
    d: "M18.057 106.862c.037-.022.081.055.103.093-.604 5.124-1.578 10.209-2.988 15.138-.015.06-.052.081-.09.102-1.916-.062-3.69-.307-5.442-.77-.333-.061-.53-.404-.477-.74l2.061-9.116c.015-.06-.007-.098-.066-.114-2.58-.696-6.244-1.73-8.823-2.425-.06-.017-.081-.055-.066-.115l1.583-5.486c.015-.06.052-.081.111-.065.532.15 10.332 2.723 14.094 3.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C31B6C",
    d: "M23.32 90.088c-2.38 1.512-4.73-2.352-2.269-3.752 2.434-1.428 4.785 2.156 2.268 3.752zm.94 2.604c-.498 2.8 3.927 3.444 4.314.644.415-2.968-3.789-3.444-4.314-.644zm4.26 4.844c-.471 2.8 4.037 3.472 4.314.644.277-2.968-3.845-3.444-4.315-.644z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.396,
    cy: 110.396,
    r: 4,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 98.396 110.396)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.198,
    cy: 29.198,
    r: 2,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 16.198 29.198)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.297,
    cy: 11.297,
    r: 3,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-174 119.297 11.297)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDebitPayment);
export default __webpack_public_path__ + "static/media/direct-debit-payment.e39db8b4.svg";
export { ForwardRef as ReactComponent };